import React from 'react';

import DataPointsBlock from '../DataPointsBlock/DataPointsBlock';
import FeedbackBlock from '../FeedbackBlock';
import Item from '../TaskDrawer/Item';
import EstimatedSavingBlock from '../EstimatedSavingBlock';
import { Flex } from '@chakra-ui/react';
import InfoList from '../InfoList';
import { PuzzleIcon } from '@spotoninc/nexus-web-assets';
import { FEEDBACK_STATE } from '../FeedbackBlock/FeedbackBlock';
import CommentBlock from '../CommentBlock';
import DescriptionBlock from '../DescriptionBlock';

/**
 * Render content for improvement tasks
 *
 * Parent
 *      TaskDrawer
 */
function ImprovementTaskContent({
  task,
  handleFeedbackSubmit,
  handleAssignUserChange,
}) {
  return (
    <>
      <div className="nexus-task-header">{task?.task_title}</div>
      <Item
        task={{
          status: task.status,
          priority: task?.priority,
          dueDate: task.dueDate || 'No due date',
          taskType: task.task_type || 'Summary',
          assignedToId: task.assigned_to_id,
          assignedUser: task.assignedUser,
          location: task?.location_label,
        }}
        handleAssignUserChange={handleAssignUserChange}
        assignmentEditable={true}
      />
      <Flex direction={'column'} gap={6} mt={6}>
        <DescriptionBlock description={task?.task_desc || ''} />
        <DataPointsBlock
          summary={task?.error_analysis_summary}
          data={task?.data_points}
        />
        {task?.impact_amount && (
          <EstimatedSavingBlock
            impact={task?.impact_amount}
            impactFrequency={task?.impact_frequency}
          />
        )}
        <InfoList
          IconElement={PuzzleIcon}
          title="How other clients solved this problem"
          data={task?.how_others_solved}
        />
        <FeedbackBlock
          value={task?.feedback_sentiment}
          onThumbsUpClick={handleFeedbackSubmit(FEEDBACK_STATE.POSITIVE)}
          onThumbsDownClick={handleFeedbackSubmit(FEEDBACK_STATE.NEGATIVE)}
        />
        <CommentBlock comment={task?.comment} />
      </Flex>
    </>
  );
}

export default ImprovementTaskContent;
